var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-step", class: _vm.extraClasses },
    [
      _c("div", { staticClass: "subscription-step__index" }, [
        _vm._v(_vm._s(_vm.displayIndex)),
      ]),
      _c("div", { staticClass: "subscription-step__content" }, [
        _vm._v(_vm._s(_vm.step.content)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }